export default __webpack_public_path__ + "static/media/17.1ea5bccd.jpg";